import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static values = {
    autoCloseTimeout: Number,
    withConfirmationOnLeave: Boolean,
    permanent: {
      type: Boolean,
      default: false
    }
  }
  static targets = ["confirmation", "content", "backdrop"]


  connect() {
    if (this.autoCloseTimeoutValue) {
      setTimeout(() => {
        this.element.close()
      }, this.autoCloseTimeoutValue)
    }

    this.stayConfirmationVisible = false
  }

  contentTargetConnected() {
    useClickOutside(this, { element: this.contentTarget })
  }

  disconnect() {
  }

  close(event) {
    this.element.close()
    this.element.remove()
  }

  reloadPage(event) {
    this.element.close()
    this.element.remove()
    window.location.reload()
  }

  stayOnPage(event) {
    event.stopPropagation()

    this.stayConfirmationVisible = false
    if (this.withConfirmationOnLeaveValue) {
      this.confirmationTarget.classList.add('hidden')
      this.backdropTarget.classList.add('hidden')
    }
  }

  leavePage(event) {
    event.stopPropagation()

    this.element.close()
    this.element.remove()
    this.stayConfirmationVisible = false
  }

  clickOutside(event) {
    if (!this.element.open) return;

    if (this.stayConfirmationVisible) {
      return;
    }

    event.stopPropagation()

    // Check if the dialog is currently open
    if (!this.element.open) return
    // check if click inside the dialog
    if (event.target.closest('.modal-box')) return

    if (this.withConfirmationOnLeaveValue) {
      this.stayConfirmationVisible = true
      this.confirmationTarget.classList.remove('hidden')
      this.backdropTarget.classList.remove('hidden')
      event.preventDefault()
    }

    // if additional confirmation is visible
    if (this.stayConfirmationVisible) return

    if (event.target.closest('.modal-overlay')) {
      if (this.permanentValue) {
        this.element.close()
      } else {
        this.element.close()
        this.element.remove()
      }
    }
  }
}
